export const userProfilePagePath = '/user';